<template>
    <a target="_blank" class="hover-overlay-link" :href="href" v-on:click="handleClick">
        <div class="hover-overlay-layer" v-if="showOverlay">
            <div class="hover-overlay-center" >
                <div class="hover-overlay-icon icon-zoom-in">
                    <i :class="iconRender"></i>
                </div>
                {{title}}
            </div>
        </div>
        <slot/>
    </a>
</template>

<script>
import dotGet from 'lodash/get';
const DEBUG = false;
export default {
    name: 'hoverOverlayLink',
    props: {
        href: {
            type: String,
            default: null,
            data: Object,
        },
        title: {
            type: String,
            default: ""
        },
        clickCallback: {
            type: Function,
            detault:null,
        },
        data: {
            type: Object,
            default: null,
        },
        showOverlay : {
            type: Boolean,
            default: true,
        },
        iconRender: {
            type: String,
            default: "fas fa-search-plus"
        }
    },
    data: function () {
        return {
        };
    },
    computed: {

    },
    methods: {
        handleClick(event) {
            if (DEBUG) { console.log("ho52: handling event, call callback if present",
                event, this.$props.data);}
            if (this.$props.clickCallback) {
                this.$props.clickCallback(event, this.$props.data);
            }
        },
    },
    // Life Cycle
    created: function () {

    },

    mounted: function () {

    },
};
</script>

<style lang="scss">
    .hover-overlay-link {
        display:flex!important;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
.hover-overlay-layer {
    &:hover {
        opacity:1;
    }
    display: flex;
    opacity: 0;
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    right:0;
    z-index:100;
    color: white;
    text-align: center;
    background: rgba(0,0,0,0.65);
    transition: all .3s;
    cursor: pointer;
    .hover-overlay-center {
        display:block;
        position:absolute;
        font-size: 1.2rem;
        line-height: 1.2rem;
        top:50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%,-50%);
        .hover-overlay-icon {
            margin: 0 0 1rem;
            line-height: 2rem;
            font-size: 2rem;
        }
    }
}


</style>
